import { BrowserRouter, useNavigate, useLocation } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { useEffect } from "react";

// Component to handle editor mode detection and redirect
function EditorRedirect() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Check if we're in editor mode (window.__EDITOR_USER__ exists)
    const isEditorMode = typeof window !== 'undefined' && (window as any).__EDITOR_USER__;
    
    // If in editor mode and at root path, redirect to /editor
    if (isEditorMode && (location.pathname === '/' || location.pathname === '')) {
      navigate('/editor', { replace: true });
    }
  }, [navigate, location.pathname]);

  return null;
}

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <EditorRedirect />
        <AppRoutes />
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
